export const LF_TOGGLE_PENCIL_ACTIVATION = 'LF_TOGGLE_PENCIL_ACTIVATION';
export const LF_TOGGLE_ERASER_ACTIVATION = 'LF_TOGGLE_ERASER_ACTIVATION';
export const LF_ERASE_ALL = 'LF_ERASE_ALL';
